import React, { forwardRef } from 'react'
import PlayerScore from './PlayerScore'
import FlipMove from 'react-flip-move';

const Scoreboard = ({ standings, title }) => (
  <div className="mdl-card mdl-shadow--2dp" id={title}>
      <div className="mdl-card__title">
          <h2 className="mdl-card__title-text">{title}</h2>
      </div>
      <table className="mdl-data-table">
          <tbody>
              <tr>
                  <th>Rank</th>
                  <th>Player</th>
                  <th>Pick</th>
              </tr>
          </tbody>
      </table>
      <FlipMove duration={750} easing="ease-out">
      {standings.map((s, index) => (
        <PlayerScore place={s.place === null ? '-' : s.place} player={s.player} pick={s.pick} key={s._id} />
      ))}
    </FlipMove>
  </div>
)

export default Scoreboard
